import { makeStyles } from "@material-ui/core";
import { Colors } from "../../../../../utils";

const makeClasses = makeStyles((theme) => ({
  formWrapper: {
    paddingBottom: theme.spacing(1),
  },
  form: {
    display: "flex",
    flexDirection: "column",
    padding: theme.spacing(4),
  },
  formInput: {
    width: "100%",

    "& > label": {
      fontFamily: theme.fontFamily.regular,
      color: Colors.rgb.contentTextSoft,
      fontSize: theme.fontSize.L,
    },

    "& > div:before": {
      borderBottom: `1px solid ${Colors.rgb.contentLineHighlighted}`,
    },
    "& > div:after": {
      borderBottom: `1px solid ${Colors.rgb.primary}`,
    },
    "& > div:hover": {
      "&:before": {
        borderBottom: `1px solid ${Colors.rgb.contentLineHighlighted} !important`,
      },
    },

    "& input": {
      fontFamily: theme.fontFamily.regular,
      color: Colors.rgb.contentText,
      fontSize: theme.fontSize.L,
    },
  },
  formInputSelect: {
    padding: "0 !important",
    width: "100%",

    "&:before": {
      borderBottom: `1px solid ${Colors.rgb.contentLineHighlighted}`,
    },
    "&:after": {
      borderBottom: `1px solid ${Colors.rgb.primary}`,
    },
    "&:hover": {
      "&:before": {
        borderBottom: `1px solid ${Colors.rgb.contentLineHighlighted} !important`,
      },
    },

    "& > div": {
      fontFamily: theme.fontFamily.regular,
      color: Colors.rgb.contentText,
      fontSize: theme.fontSize.L,
    },
  },
  formInputSeparator: {
    height: theme.spacing(2),
  },
  formSeparator: {
    height: theme.spacing(1),
  },
  contentActionsWrapper: {
    width: '100%',
    display: "flex",
    justifyContent: "flex-end",
    alignItems: "center",

    "& > button:last-child": {
      marginRight: 0,
    },
  },
  contentActionSeparator: {
    width: theme.spacing(3),
  },
  autoApprovalWrapper: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start",
    margin: `${theme.spacing(6)} 0 ${theme.spacing(2)}`,
  },
  autoApprovalLabel: {
    display: "block",
    fontFamily: theme.fontFamily.regular,
    color: Colors.rgb.contentText,
    fontSize: theme.fontSize.L,
  },
  autoApprovalInputDisabledWrapper: {
    opacity: 0.5,
  },
  //
  planDetailsItem: {
    fontFamily: theme.fontFamily.regular,
    color: Colors.rgb.contentTextHighlighted,
    fontSize: theme.fontSize.L,

    "& > div": {
      color: Colors.rgb.contentText,
      fontSize: theme.fontSize.M,
    },

    '& a': {
      color: Colors.rgb.primary
    }
  },
  planDetailsItemDisabled: {
    opacity: 0.5,
  },
  subscriptionDetailsStatus: {
    display: "inline-block",
    padding: `${theme.spacing(1)} ${theme.spacing(2)}`,
    borderRadius: 5,
    fontSize: theme.fontSize.S,
  },
  subscriptionDetailsStatusActive: {
    background: Colors.rgb.alertSuccessBackground,
    border: `1px solid ${Colors.rgb.alertSuccessBorder}`,
    color: `${Colors.rgb.alertSuccessText} !important`,
  },
  subscriptionDetailsStatusInactive: {
    background: Colors.rgb.alertDangerBackground,
    border: `1px solid ${Colors.rgb.alertDangerBorder}`,
    color: `${Colors.rgb.alertDangerText} !important`,
  },
  callbackCheckboxWrapper: {
    overflow: "hidden",
    display: "flex",

    [theme.breakpoints.down("sm")]: {
      justifyContent: "flex-start",
    },
  },
  additionalFieldContent: {
    display: "flex",
    gap: theme.spacing(4),
  },
  additionalFieldWrapper: {
    border: `1px solid ${Colors.rgb.contentLineHighlighted}`,
    padding: '0.938rem 1.25rem',
    margin: `1.25rem 0`,
    borderRadius: '10px',
    gap: theme.spacing(2),
  },
  additionalFieldNumber: {
    backgroundColor: '#888',
    color: Colors.rgb.white,
    height: '1.875rem',
    width: '1.875rem',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: '10px'
  },
  additionalFieldNumberSelected: {
    backgroundColor: Colors.rgb.primary
  },
  additionalFieldActions: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    marginTop: theme.spacing(2),
  },
  checkbox: {
    borderRadius: '100%'
  },
  suscriptionDetailsItem: {
    fontFamily: theme.fontFamily.regular,
    color: Colors.rgb.contentTextHighlighted,
    fontSize: theme.fontSize.M,
    wordBreak: 'break-word',

    '& > div': {
      color: Colors.rgb.contentText,
      fontSize: theme.fontSize.S,
    },

    '& a': {
      color: Colors.rgb.primary
    }
  },
  additionalTextLabel: {
    color: Colors.rgb.contentTextHighlighted,
    fontSize: theme.fontSize.M,
    marginTop: theme.spacing(4),
    marginBottom: theme.spacing(2)
  },
  multipleSubsContainer: {
    border: `1px solid #D1D5DE`,
    borderRadius: "10px",
    padding: '20px 20px 40px'
  },
  checkboxContainer: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  }
}));

export default makeClasses;
